module.exports = __webpack_public_path__ + "img/USERS_GROUP.c91581bc.svg";